import type {
  Integration,
  IntegrationConnectionState,
} from "../portals/messagemedia/hooks";

export type IntegrationState = {
  status: "INACTIVE" | "ACTIVE";
  integration: string;
};

export type IntegrationConnectionStateType = {
  store_id?: string;
  state?: "CONNECTED" | "COMPLETED";
};

export const isIntegrationActive = (
  integrationStates: IntegrationState[],
  integrationName: string
): boolean =>
  integrationStates.some(
    (integration) =>
      integration.integration === integrationName &&
      integration.status === "ACTIVE"
  );

export const getAllIntegrations = (
  integrationStates: IntegrationState[]
): IntegrationState[] => integrationStates;

export const getAllConnectionStates = (
  connectionStates: IntegrationConnectionStateType[]
): IntegrationConnectionStateType[] => connectionStates;

export const isIntegrationActiveFromContext = (
  integrations: Record<string, Integration | null>,
  integrationName: string
): boolean => {
  const integration = integrations[integrationName];
  return integration?.status === "ACTIVE";
};

export const getAllIntegrationsFromContext = (
  integrations: Record<string, Integration | null>
): Integration[] =>
  Object.values(integrations).filter(
    (integration): integration is Integration => integration !== null
  );

export const getAllConnectionStatesFromContext = (
  connectionStates: Record<string, IntegrationConnectionState | null>
): IntegrationConnectionState[] =>
  Object.values(connectionStates).filter(
    (connection): connection is IntegrationConnectionState =>
      connection !== null
  );
